module.exports = __webpack_public_path__ + "static/img/zwtp.223ebd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zwtp.jpg
// module id = 0fMi
// module chunks = 4